/* eslint-disable camelcase */

import PropTypes from 'prop-types';
import React, {Component} from 'react';
import cN from 'classnames';

import {hyphenize} from 'utils/text';
import Range from 'scripts/components/Range';


class Slider extends Component {

    static canContinue(answer, config) {
        const {answer_optional: isAnswerOptional} = config;
        if (isAnswerOptional) {
            return false;
        }

        return !Boolean(answer && typeof answer.value === 'number');
    }

    render() {
        const {config, answer, showHandle} = this.props;
        const {min, max, step, center_label, min_label, max_label, continuity, position, show_values} = config;
        const {value = null} = answer;

        return (
            <div className={cN('slider-block no-handle', {untouched: value === null})}>
                <div className="labels">
                    {min_label && (
                        <div className="label">
                            <span className="label-left">
                                {hyphenize(min_label)}
                            </span>
                        </div>
                    )}
                    {center_label && (
                        <div className="label">
                            <span className="label label-center">
                                {hyphenize(center_label)}
                            </span>
                        </div>
                    )}
                    {max_label && (
                        <div className="label">
                            <span className="label label-right">
                                {hyphenize(max_label)}
                            </span>
                        </div>
                    )}
                </div>
                <Range
                    min={min}
                    max={max}
                    step={step}
                    value={value}
                    continuity={continuity}
                    position={position}
                    showHandle={showHandle}
                    showNumbers={show_values}
                    onChange={this.onChange}
                />
            </div>
        );
    }

    onChange = event => {
        const {updateAnswer} = this.props;
        const value = +event.currentTarget.value;
        updateAnswer({value});
    };
}

Slider.propTypes = {
    config: PropTypes.shape({
        min: PropTypes.number,
        max: PropTypes.number,
        step: PropTypes.number,
        min_label: PropTypes.string,
        max_label: PropTypes.string,
        center_label: PropTypes.string,
        continuity: PropTypes.oneOf([Range.DISCRETE, Range.CONTINUOUS]).isRequired,
        position: PropTypes.oneOf([Range.POSITION_RANDOM, Range.POSITION_CENTERED]).isRequired,
        showNumbers: PropTypes.bool,
    }).isRequired,
    answer: PropTypes.shape({
        value: PropTypes.number,
    }).isRequired,
    updateAnswer: PropTypes.func.isRequired,
};

export default Slider;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/Slider.js